import React from "react";
import { useSelector } from "react-redux";
import { Image } from "cloudinary-react";
import { Link } from "react-router-dom";
import { FaTag } from "react-icons/fa";
import "./styles.css";

const HotSale = () => {
  const { loading, product: featuredProduct } = useSelector(
    (state) => state.featuredProduct
  );

  if (!featuredProduct || Object.keys(featuredProduct).length === 0)
    return null;

  return (
    <div>
      {loading ? (
        "loading"
      ) : (
        <section
          id="yearly-sale"
          className="overflow-hidden mt-5"
          style={{
            background: "#EDF1F3",
            padding: "80px 0px",
            marginBottom: "50px",
          }}
        >
          <div className="container">
            {/* Responsive flexbox: row on large screens, column on small */}
            <div className="featured-container row d-flex flex-column flex-md-row align-items-center justify-content-center text-center text-md-start">
              {/* Text Content */}
              <div className="col-md-6 col-sm-12 d-flex flex-column justify-content-center align-items-center align-items-md-start">
                <div className="text-content padding-medium">
                  {!!featuredProduct.capacity[0].details[0].discount && (
                    <span
                      className="discount-badge"
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        padding: "7px",
                        borderRadius: "12px",
                        fontWeight: 500,
                        marginBottom: "12px",
                        fontSize: "20px",
                      }}
                    >
                      {/* <FaTag />{" "} */}
                      {(
                        (featuredProduct.capacity[0].details[0].discount /
                          featuredProduct.capacity[0].details[0].price) *
                        100
                      ).toFixed(2)}
                      % OFF
                    </span>
                  )}
                  <h2
                    className="display-2 pb-3 text-uppercase"
                    style={{
                      fontWeight: 500,
                      fontSize: "48px",
                    }}
                  >
                    {featuredProduct?.productName}
                  </h2>
                  <h5>{featuredProduct?.description}</h5>
                  <Link
                    to={`/product/${featuredProduct._id}/`}
                    className="btn btn-medium btn-black"
                    style={{
                      marginTop: "22px",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#514f4f";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "black";
                      e.target.style.color = "white";
                    }}
                  >
                    Shop Now
                  </Link>
                </div>
              </div>

              {/* Image Section (Below text on small screens) */}
              <div className=" col-md-6 col-sm-12 d-flex justify-content-center">
                <Image
                  cloudName="dljielsye"
                  class="featured-container-image"
                  publicId={featuredProduct.image?.[0] || ""}
                  style={{
                    maxWidth: "100%",
                    height: "500px",
                    objectFit: "contain",
                  }}
                />
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default HotSale;
